import React, { useState } from "react";
import { AppLayout } from "../../../templates";
import { Box, Grid, Tab, Tabs } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { factoryActions, alertActions } from "../../../_redux/actions";
import { authorizationService } from "../../../_services";
import { models as BiModels, Report as BiReport, Embed as BiEmbed, service as BiService } from 'powerbi-client';
import ActualCycleTimeReport from "../../../components/reports/actualCycleTime/ActualCycleTimeReport";
import PaceMakerReport from "../../../components/reports/paceMaker/PaceMakerReport";
import { FactoryStudySummary, SbuStudySummary, PlantOrSBUWiseOperationCyclesAndBestCTs } from "../../../components";

const YamazumiReportsPage = () => {
    const [activeTab, setActiveTab] = React.useState(0);
    const [report, setReport] = useState<BiReport>();
    const [sampleReportConfig, setReportConfig] = useState<BiModels.IReportEmbedConfiguration>({
        type: 'report',
        embedUrl: undefined,
        tokenType: BiModels.TokenType.Aad,
        accessToken: undefined,
        settings: undefined,
    });

    // useEffect(() => {

    //     tokenPromis.then((token) => {
    //         setReportConfig({
    //             ...sampleReportConfig,
    //             embedUrl: "https://app.powerbi.com/reportEmbed?reportId=d55ddd34-d5c4-4ef9-a7d4-8c55fd434d8f",
    //             accessToken: token.accessToken
    //         });
    //     });
    // }, [activeTab]);

    interface TabPanelProps {
        children?: React.ReactNode;
        index: number;
        value: number;
    }

    const TabPanel = (props) => {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`mat-${index}`}
                {...other}
            >
                {value === index && (
                    <Box width="100%">
                        {value === index && children}
                    </Box>
                )}
            </div>
        );
    }

    const handleChange = (event: any, newValue: number) => {
        setActiveTab(newValue);
    };


    const dispatch = useDispatch();

    const a11yProps = (index: number) => {
        return {
            id: `bi-report-tab-${index}`,
            'aria-controls': `bi-report-tabpanel-${index}`,
        };
    };

    // Map of event handlers to be applied to the embedding report
    const eventHandlersMap = new Map([
        ['loaded', function () {
            console.log('Report has loaded');
        }],
        ['rendered', function () {
            console.log('Report has rendered');

            // Update display message
            //setMessage('The report is rendered')
        }],
        ['error', function (event?: BiService.ICustomEvent<any>) {
            if (event) {
                console.error(event.detail);
            }
        }]
    ]);

    React.useEffect(() => {
        // dispatch getAllSbuList action & fetch SBU List
        dispatch(
            factoryActions.getAllSbuList(
                authorizationService.getAuthorizedUser().isAdmin,
                authorizationService.getAuthorizedUser().userEmail,
                () => { },
                (error) => {
                    dispatch(alertActions.triggerAlert(true, error, 'error'))
                }
            )
        );
    }, []);

    return (
        <AppLayout>
            <Grid container className={'appPageHeader'}>
                <Grid container item xs={12} sm={12} md={7} lg={7} justify="flex-start" alignContent="center">
                    <span className={'pageTitle'}><b>Reports</b></span>
                </Grid>
                <Grid container item xs={12} sm={12} md={5} lg={5} justify="flex-end" alignContent="center">

                </Grid>
            </Grid>
            <div className="appPageContent">
                <Box>
                    <Tabs value={activeTab} onChange={handleChange} aria-label="List of Reports" className="appTabGroup">
                        <Tab label="Actual Cycle Time" {...a11yProps(0)} />
                        <Tab label="Pace Maker" {...a11yProps(1)} />
                        <Tab label="SBU Study Summary" {...a11yProps(2)} />
                        <Tab label="Factory Study Summary" {...a11yProps(2)} />
                        <Tab label="Best CT Report" {...a11yProps(2)} />
                    </Tabs>
                </Box>
                <TabPanel value={activeTab} index={0}>
                    <ActualCycleTimeReport></ActualCycleTimeReport>
                </TabPanel>
                <TabPanel value={activeTab} index={1}>
                    <PaceMakerReport></PaceMakerReport>
                </TabPanel>
                <TabPanel value={activeTab} index={2}>
                    <SbuStudySummary />
                </TabPanel>
                <TabPanel value={activeTab} index={3}>
                    <FactoryStudySummary />
                </TabPanel>
                <TabPanel value={activeTab} index={4}>
                    <PlantOrSBUWiseOperationCyclesAndBestCTs />
                </TabPanel>
            </div>
        </AppLayout>
    );
}

export default YamazumiReportsPage;
